export default __webpack_public_path__ + "static/media/Ruth.3ffbf573.jpg";